import { computed } from 'vue'
import { useRogue } from '@/js/services/Rogue'

export function useCookieManagement() {
  const COOKIE_NAME = 'cookiePreferences'
  const MARKETING_COOKIES = ['_fbp', 'fr']
  
  const rogue = useRogue()

  // @ts-expect-error: globalPrivacyControl is not yet a standard part of the DOM
  const gpcValue = typeof navigator !== 'undefined' ? !!navigator?.globalPrivacyControl : false

  const hasCookiePolicy = computed(() =>
    ['EUR', 'GBR'].includes(rogue.site.code)
  )

  // Where consent is opt-in, every optional category starts off until the visitor chooses
  const requiresCookieOptIn = computed(() =>
    ['EUR', 'GBR', 'CAN'].includes(rogue.site.code)
  )

  function removeCookie(cookieName: string) {
    const hostname = window.location.hostname
    const index = hostname.indexOf('.')
    const domainName = hostname.substring(index)

    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domainName}`
  }

  const policyText = computed(() =>
    hasCookiePolicy.value ? 'Cookie Policy' : 'Privacy Policy'
  )

  const policyLink = computed(() =>
    hasCookiePolicy.value ? '/about-cookies' : '/privacy-policy'
  )

  return { hasCookiePolicy, requiresCookieOptIn, policyText, policyLink, gpcValue, removeCookie, COOKIE_NAME, MARKETING_COOKIES}
}
